import SignaturesView from '../SignaturesView.vue'
import SignatureInbox from '../Pages/SignatureInbox.vue'

// CDEF014 §3: bandeja de quien firma por la empresa.
const routes = [
  {
    path: '/firmas',
    component: SignaturesView,
    children: [
      { path: '', name: 'signature-inbox', component: SignatureInbox },
    ],
  },
]

export default routes
